import { render, staticRenderFns } from "./clientesEditar.vue?vue&type=template&id=d87dde8e&scoped=true&"
import script from "./clientesEditar.vue?vue&type=script&lang=js&"
export * from "./clientesEditar.vue?vue&type=script&lang=js&"
import style0 from "./clientesEditar.vue?vue&type=style&index=0&id=d87dde8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87dde8e",
  null
  
)

export default component.exports